export function getConvertedNumberAndPrefixSuffix (num: number, prefix: string, suffix: string): {
    number: string | number;
    prefix: string;
    suffix: string;
} {
    let number: string | number = num;
    let suff = suffix;
    if (number > 1000 && suffix.includes('MW')) {
        number = Math.round(((number / 1000) + Number.EPSILON) * 100) / 100;
        number = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        suff = suffix.replace('MW', 'GW');
    }
    return {
        number,
        prefix,
        suffix: suff,
    };
}

export function formatMetricNumber (value: string | Array<string>): string | number {
    const formatter = (numberString: string): string | number => {
        const number = parseFloat(numberString);
        if (number === 0) return 0;
        if (Math.abs(number) >= 100) return number.toFixed(0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return number.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    if (value === '-') return '-';

    if (Array.isArray(value) && value.length > 0) {
        return value.map((val) => formatter(val)).join(', ');
    }
    if (typeof value === 'string') return formatter(value);
    return '';
}

export function formatNumberToMaxDecimalPlaces (value: number, decimalPlaces = 2): string {
    return Number(value.toFixed(decimalPlaces)).toString();
}

export function toNearest (num: number, nearest: number): number {
    return Math.round(num / nearest) * nearest;
}

export function roundUpSignificantFigures (num: number, sigFigs: number): number {
    if (num === 0) return 0;
    const magnitude = Math.floor(Math.log10(Math.abs(num)));
    const factor = 10 ** (magnitude - sigFigs + 1);
    return Math.ceil(num / factor) * factor;
}

export function binarySearchClosest (data: number[], target: number): number {
    let low = 0;
    let high = data.length - 1;

    while (low <= high) {
        // eslint-disable-next-line no-bitwise
        const mid = (low + high) >>> 1;
        const val = data[mid];

        if (val < target) low = mid + 1;
        else if (val > target) high = mid - 1;
        else return mid;
    }

    const idx1 = low;
    const idx2 = low - 1;

    if (idx1 >= data.length) return idx2;
    if (idx2 < 0) return idx1;

    return (Math.abs(data[idx1] - target) < Math.abs(data[idx2] - target)) ? idx1 : idx2;
}
